import { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Loader from "@/components/Loader";
import Home from "@/pages/Home";

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    document.body.style.overflow = loaded ? "" : "hidden";
  }, [loaded]);

  return (
    <div className="App min-h-screen bg-white font-body">
      {!loaded && <Loader onDone={() => setLoaded(true)} />}
      <SmoothScroll>
        <Cursor />
        <Navbar />
        <main>
          <Home ready={loaded} />
        </main>
        <Footer />
      </SmoothScroll>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
